import * as React from 'react';
import * as ReactDOM from 'react-dom';
import AddedToCartModal from '../components/AddedToCardModal';

interface Params {
    elementId: string;
    name: string;
    price: string;
    imageUrl: string;
    editCartUrl: string;
    proceedUrl: string;
}

const renderOpenAddToCardModal = (params: Params): void => {
    const newEl = document.createElement('div');
    newEl.id = params.elementId;
    document.body.appendChild(newEl);
    const addedToCartModal = (
        <AddedToCartModal
            name={params.name}
            price={params.price}
            imageUrl={params.imageUrl}
            editCartUrl={params.editCartUrl}
            proceedUrl={params.proceedUrl}
        />
    );
    ReactDOM.render(addedToCartModal, newEl);
};

export default renderOpenAddToCardModal;
